// extracted by mini-css-extract-plugin
export default {"container":"AHVLQA","title":"TSx69m","description":"leUsPN"};